export { default } from "./creditCard.svelte";
